interface QueueItem<Key, Result> {
    key: Key;
    resolve: (result: Result) => any;
    reject: (error: string) => any;
}

export abstract class ACombineApiCalls<Key, Result> {
    private queue: QueueItem<Key, Result>[] = [];

    constructor(private callSize: number = 10, private debounceTimer: number = 20) { }

    public get(key: Key): Promise<Result> {

        return new Promise<Result>((resolve, reject) => {
            setTimeout(this.buildCall.bind(this), this.debounceTimer);
            // Why is debounce not working?!
            //debounce(this.buildCall.bind(this), this.debounceTimer);
            this.queue.push({ key, resolve, reject });
        });
    }

    abstract call(keys: Key[]): Promise<Result[]>;

    abstract matches(key: Key, result: Result): boolean;

    private buildCall(): void {
        let queueItems: QueueItem<Key, Result>[] = [];
        let keys: Key[] = [];
        for (let no = 0; no < this.callSize && this.queue.length > 0; no++) {
            let item = this.queue.shift();
            queueItems.push(item);
            keys.push(item.key);
        }
        if (keys.length == 0) return;
        this.call(keys).then(result => {
            for (let resultItem of result) {
                for (let i = 0; i < queueItems.length; i++) {
                    let queueItem = queueItems[i];
                    if (this.matches(queueItem.key, resultItem)) {
                        queueItem.resolve(resultItem);
                        queueItems.splice(i, 1); // Remove item from array
                    }
                }
            }
            for (let queueItem of queueItems) {
                queueItem.reject('Not found in result');
            }
        }).catch(e => {
            for(let queueItem of queueItems){
                queueItem.reject(e);
            }
        });

    }
}